 
import { listEstimate, saveEstimate, updateEstimate, updateGroup } from '@/api/enterprise'
import layerContent from './layer-content'
export default {
  components: {
  },
  props: ['info', 'isMove', 'isEdit'],
  data() {    
    return {
        list: [],
        form: {
            estimate_name: '',
            group_id: '',
            estimate_data: {
                C2: 0
            },
            id: '',
        },
        layerLoading: false,
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    save() {
        this.$refs['form'].validate( async (valid) => {
            if (valid) {
                this.layerLoading = true
                let res
                if (this.form.id) {
                    if (this.isEdit) {
                        res = await updateEstimate({estimate_name: this.form.estimate_name, id: this.form.id})
                    } else if (this.isMove) {
                        res = await updateGroup({group_id: this.form.group_id, id: this.form.id})
                    } else {
                        res = await updateEstimate({group_id: this.form.group_id, estimate_name: this.form.estimate_name, id: this.form.id})
                    }
                    
                } else {
                    res = await saveEstimate(this.form)
                }
                
                this.layerLoading = false
                this.$layer.closeAll()
                this.$parent.fetch()                
                if (!this.form.id) {
                    this.$layer.iframe({
                        content: {
                        content: layerContent, //传递的组件对象
                        parent: this,//当前的vue对象      
                        data:{
                            estimate_data: this.form.estimate_data,
                            cesuanTitle: this.form.estimate_name,
                            id: res.data.estimate_id,
                            group_id: this.form.group_id
                        }//props
                        },
                        isOutAnim: false,
                        maxmin: true,
                        time: 0,
                        shadeClose: false,
                        resize: true,
                        scrollbar: false,
                        area:['1200px','650px'],
                        title: this.form.estimate_name,
                        skin: 'custom-layer-class',
                        cancel: function() {
                        // 这个函数将在层关闭时调用
                        // $('#mapboxglDef').click()
                        }
                    });
                    setTimeout( () => {
                        $('.vl-notify-content').addClass('custom-layer-class')
                    }, 800)
                }
            }
            
        })
        
    },
    async getList() {
        const res = await listEstimate({})
        this.list = res.data
        if (!this.info) {
            this.$set(this.form, 'group_id', this.list[0].group_id)
        } else {            
            this.form = this.info         
        }
        
    },
  }
}
